import React from 'react';
import type { FC, PropsWithChildren } from 'react';
import classes from '../styles/Input.module.css';

type SelectBoxProps = PropsWithChildren<{
  icon?: string;
  label: string;
  name?: string;
  valid?: boolean;
  required?: boolean;
  placeholder?: string;
  errorMessage?: string;
  style?: React.CSSProperties;
  type?: React.HTMLInputTypeAttribute;
  containerStyle?: React.CSSProperties;
  onChange?: React.ChangeEventHandler<HTMLSelectElement>;
  value?: string | ReadonlyArray<string> | number | undefined;
}>;

const SelectBox: FC<SelectBoxProps> = props => {
  const handleFocus = () => {
    const textInput = document.getElementById(props.label);
    const textInputIcon = document.getElementById(props.label + 'icon');
    // const textInput = document.querySelector<HTMLElement>('.' + classes.inputBox);
    // const textInputIcon = document.querySelector<HTMLElement>('.' + classes.inputBox__icon);
    if (textInput) textInput.style.border = '1px solid var(--grey)';
    if (textInputIcon) textInputIcon.style.fill = 'var(--black)';
  };

  const handleFocusOut = () => {
    const textInput = document.getElementById(props.label);
    const textInputIcon = document.getElementById(props.label + 'icon');
    // const textInput = document.querySelector<HTMLElement>('.' + classes.inputBox);
    // const textInputIcon = document.querySelector<HTMLElement>('.' + classes.inputBox__icon);
    if (textInput) textInput.style.border = '1px solid var(--light-grey)';
    if (textInputIcon) textInputIcon.style.fill = 'var(--grey)';
  };

  return (
    <div className={classes.container} style={props.containerStyle}>
      <label className={classes.label}>{props.label}</label>
      <div className={classes.inputBox} id={props.label}>
        {props.icon && (
          <svg className={classes.inputBox__icon} id={props.label + 'icon'}>
            <use xlinkHref={`/assets/sprite.svg#icon-${props.icon}`} />
          </svg>
        )}
        <select
          className={classes.textInput__input}
          name={props.name}
          value={props.value}
          style={{ ...props.style, width: props.valid ? '90%' : '100%' }}
          onChange={props.onChange}
          onFocus={handleFocus}
          onBlur={handleFocusOut}
        >
          {props.children}
        </select>

        {props.valid && (
          <svg className={classes.inputBox__icon_check}>
            <use xlinkHref={`/assets/sprite.svg#icon-checkmark`} />
          </svg>
        )}
      </div>
      {props.errorMessage ? <p className={classes.errorText}>{props.errorMessage}</p> : ''}
    </div>
  );
};

export default SelectBox;
